import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.config.devtools = true;
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    addonProducts: [],
    categories: [],
    selectedSort: "1",
    selectedSortMobile: "1",
    selectedCategory: ["View All"],
    selectedCategoryMobile: ["View All"],
    rangePrice: {min:0,max:100},
    rangePriceMobile: {min:0,max:100},
  },
  getters,
  mutations,
  actions,
});

export default store;
